import type { FaireProductEntity } from "../../entity_types/product";

export const p_dhngknqnc9: FaireProductEntity = {
  token: "p_dhngknqnc9",
  type: "product",
  name: "Bundle of Joy Mini Kit - EWG & Fragrance Free",
  brandToken: "b_2vgr3yu7bj",
  brandName: "Dabble & Dollop®",
  imageUrl:
    "https://cdn.faire.com/fastly/4228ca63d948a46f4a2c227e5bc86ac8c2e8c55c9ff73ba0f9b459ae044a70b3.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/728910364535e43c94848e91b53631990f5647c753a2d0fbabc6fb378e27bd92.jpeg",
    "https://cdn.faire.com/fastly/b7258f6cb559dfe62eb1a096bec33b4382c3302fbf1d4f3d955f42aec7b3bee9.jpeg",
    "https://cdn.faire.com/fastly/d783afb52c88fd3301f3eff35932184d12d6b456e617d49d77b1497d5ea7fc26.jpeg",
    "https://cdn.faire.com/fastly/712cb82087e5949f51177751c3d2ffddfc0660befbbb8e312615eee1d1527d7d.jpeg",
  ],
  priceDollars: 7.49,
  description:
    "A travel-ready, giftable intro to Dabble & Dollop Baby. This fragrance-free 3-piece mini set gently cleanses, soothes, and hydrates delicate newborn skin.\n\nIncludes:\n• Sensory Suds Bubble Bath (2 oz)\n• Lullaby Lather Hair & Body Wash (1 oz)\n• Cuddle Cloud All-Over Lotion (1 oz)\n\npH-balanced at 5.5 to support baby’s skin barrier. Made with fewer, better ingredients. Vegan, cruelty-free, and EWG Verified®.\n\nShelf-ready gift box makes it perfect for baby showers, Easter baskets, Mother’s Day, hospital bags, and travel. Ideal discovery set to drive full-size sales.",
  tags: [],
  msrpDollars: 14.99,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T19:26:37.536Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
